import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import "./productdetails.css";
import Header from '../header/Header';
import { IoArrowBack, IoArrowForward } from "react-icons/io5";
import { FaSearchPlus } from 'react-icons/fa';
import { FiEdit2, FiMinus, FiPlus, FiTrash2 } from 'react-icons/fi';
import axiosConfig from "../../Services/axiosConfig"
import RelatedProducts from './RelatedProducts';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch, useSelector } from 'react-redux';
import { addToBuyCart, addToRentCart, decreaseBuyQty, decreaseRentQty, removeFromRentCart } from '../../redux/cartSlice';
import { toast } from 'react-toastify';
import Wishlist from '../WishList/Wishlist';
import { generateUUID } from '../../utils/RandomId';
import ConfigureRentalModal, { getPackageForPlan, calculateConfigPrice } from './ConfigureRentalModal';

/* ── Rental plan metadata ── */
const ALL_RENTAL_PLANS = [
    { key: 'daily',    label: 'Daily',    unit: 'day',   unitPlural: 'days' },
    { key: 'weekly',   label: 'Weekly',   unit: 'week',  unitPlural: 'weeks' },
    { key: 'monthly',  label: 'Monthly',  unit: 'month', unitPlural: 'months' },
    { key: 'annually', label: 'Annually', unit: 'year',  unitPlural: 'years' },
];

function getDefaultPlanKey(packages) {
    if (!Array.isArray(packages) || packages.length === 0) return 'daily';
    for (const plan of ALL_RENTAL_PLANS) {
        const found = packages.find(
            (pkg) => (pkg.package_name || '').toLowerCase() === plan.label.toLowerCase()
        );
        if (found) return plan.key;
    }
    return 'daily';
}

const RENT_CONFIG_STORAGE_KEY = "rentConfigurations";

function loadStoredConfigs(variantId) {
    try {
        const all = JSON.parse(localStorage.getItem(RENT_CONFIG_STORAGE_KEY) || "{}");
        return Array.isArray(all[variantId]) ? all[variantId] : [];
    } catch {
        return [];
    }
}

function saveStoredConfigs(variantId, configs) {
    try {
        const all = JSON.parse(localStorage.getItem(RENT_CONFIG_STORAGE_KEY) || "{}");
        all[variantId] = configs;
        localStorage.setItem(RENT_CONFIG_STORAGE_KEY, JSON.stringify(all));
    } catch { /* ignore */ }
}

const formatDurationDisplay = (duration, planKey) => {
    const key = (planKey || "").toLowerCase().trim();
    let planMeta = ALL_RENTAL_PLANS.find((p) => p.key === key);
    if (!planMeta) {
        planMeta = ALL_RENTAL_PLANS.find(
            (p) => key.includes(p.key) || key.includes(p.label.toLowerCase())
        );
    }
    if (!planMeta) planMeta = ALL_RENTAL_PLANS[0];
    return `${duration} ${duration === 1 ? planMeta.unit : planMeta.unitPlural}`;
};

function Productdetails() {
    const { state } = useLocation();
    console.log(state, "fahhhhhhh")
    const dispatch = useDispatch();
    const { friendlyurl } = useParams();
    const [currentIndex, setCurrentIndex] = useState(0);
    const [product, setProduct] = useState({});
    const [productDetails, setProductDetails] = useState()
    const [isZoomed, setIsZoomed] = useState(false)
    const [listingType, setListingType] = useState('buy');
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [wishListed, setWishListed] = useState(false)
    const [error, setError] = useState("")
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
    const [pricePackages, setPricePackages] = useState([]);
    const [selectedPlanKey, setSelectedPlanKey] = useState('daily');

    // ── Configure Rental Modal state ──
    const [showConfigureModal, setShowConfigureModal] = useState(false);
    const [rentConfigurations, setRentConfigurations] = useState([]);
    const [editingConfigId, setEditingConfigId] = useState(null);

    // ── Cart state from Redux ──
    const buyCart = useSelector((s) => s.cart.buyCart);
    const rentCart = useSelector((s) => s.cart.rentCart);
    const buyCartItem = buyCart.find((i) => i.id === productDetails?.id);
    const rentCartItem = rentCart.find((i) => i.id === productDetails?.id);
    const cartItem = selectedOption === 'rent' ? rentCartItem : buyCartItem;
    const cartQty = cartItem?.qty || 0;
    const currentStock =
        listingType === "rental"
            ? product?.rental_stock
            : product?.sale_stock;

    const effectiveVariantId = productDetails?.id;

    // ── Sync fromDate from existing cart item ──
    useEffect(() => {
        if (rentCartItem?.fromDate && !fromDate) {
            const [year, month, day] = rentCartItem.fromDate.split("-").map(Number);
            setFromDate(new Date(year, month - 1, day));
        }
    }, [rentCartItem?.fromDate]);

    // ── Restore configs from localStorage, pruning any whose cart items are gone ──
    useEffect(() => {
        if (!effectiveVariantId) return;
        const stored = loadStoredConfigs(effectiveVariantId);
        const liveCartItemIds = new Set(rentCart.map((i) => i.cartItemId));
        const active = stored.filter((c) => liveCartItemIds.has(c.id));
        setRentConfigurations(active);
        setEditingConfigId(null);
        if (active.length !== stored.length) {
            saveStoredConfigs(effectiveVariantId, active);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [effectiveVariantId]);

    // ── Keep config list in sync when rentCart changes externally ──
    useEffect(() => {
        if (!effectiveVariantId) return;
        const liveCartItemIds = new Set(rentCart.map((i) => i.cartItemId));
        setRentConfigurations((prev) => {
            const next = prev.filter((c) => liveCartItemIds.has(c.id));
            if (next.length !== prev.length) {
                saveStoredConfigs(effectiveVariantId, next);
            }
            return next;
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rentCart]);

    let navigate = useNavigate()
    const formatPrice = (price) =>
        price?.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        }).replace("$", "$ ");

    useEffect(() => {
        if (productDetails?.varient_listing_type) {
            const apiListingType = productDetails.varient_listing_type;
            setListingType(apiListingType);
            if (apiListingType === 'buy') {
                setSelectedOption('buy');
            } else if (apiListingType === 'rent') {
                setSelectedOption('rent');
            } else if (apiListingType === 'buy/rent') {
                setSelectedOption(state?.listingType === 'rent' ? 'rent' : 'buy');
            }
        }
    }, [productDetails, state?.listingType]);

    const userId = localStorage.getItem("userid");
    const fetchIsWishlist = useCallback(async () => {
        try {
            const res = await axiosConfig.get(`/catlog/wishlist-check/?variant_id=${productDetails.id}&type=${selectedOption}`)
            setWishListed(res?.data)
        } catch (error) {
            console.log(error)
        }
    }, [productDetails?.id, selectedOption])

    useEffect(() => {
        if (!userId) return;
        if (!productDetails?.id) return;
        if (!selectedOption) return;
        fetchIsWishlist()
    }, [productDetails?.id, selectedOption])

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [friendlyurl]);

    useEffect(() => {
        async function fetchFullProduct() {
            const res = await axiosConfig.get(`/catlog/seo-url/${friendlyurl}`);
            setProduct(res.data.product_data);
        }
        async function fetchProductDetails() {
            const variantId =
                state?.item?.varient?.id ||
                state?.item?.id;
            try {
                const res = await axiosConfig.get(`/catlog/product-variant-detail/${variantId}`);
                setProductDetails(res.data)
            } catch (error) {
                console.log(error)
            }
        }
        fetchFullProduct();
        fetchProductDetails()
    }, [friendlyurl, state?.item?.id]);

    // ── Fetch variant price packages when productDetails loads ──
    useEffect(() => {
        const variantId = productDetails?.id;
        if (!variantId) return;
        axiosConfig
            .get(`/catlog/variant-price-packages/?product_variant=${variantId}&active=true`)
            .then((res) => {
                const pkgs = res.data?.results || [];
                setPricePackages(pkgs);
                setSelectedPlanKey(getDefaultPlanKey(pkgs));
            })
            .catch(() => setPricePackages([]));
    }, [productDetails?.id]);

    const images = productDetails?.images.map((img) => img.image) || [];

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) =>
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    function handleListingSwitch(type) {
        setError("")
        const urlType = type === "buy" ? "buy" : "rent";
        navigate(`/product/${friendlyurl}`, {
            state: { item: state?.item, listingType: urlType },
        });
    }

    function formatLocalDate(date) {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    }

    const activePackage = useMemo(
        () => getPackageForPlan(pricePackages, selectedPlanKey),
        [pricePackages, selectedPlanKey]
    );

    // ── Build cart item id ──
    const buildCartItemId = (plan, duration, startDate) =>
        `${effectiveVariantId}-${plan}-${duration}-${startDate}-${Date.now()}`;

    // ── Add a config entry to the redux rent cart ──
    const addRentConfigToCart = (configData, cartItemId) => {
        const safeQty = Math.max(1, Number(configData.qty) || 1);
        const offerPrice = configData.rentalCharges?.final_cost
            ? Number(configData.rentalCharges.final_cost) / safeQty
            : configData.selectedPackage
                ? Number(configData.selectedPackage.offer_price) /
                  Number(configData.selectedPackage.duration_value || 1)
                : Number(productDetails?.prices?.rental_price || 0);
        const originalRentalPrice = configData.rentalCharges?.base_cost
            ? Number(configData.rentalCharges.base_cost) / safeQty
            : configData.selectedPackage &&
              Number(configData.selectedPackage.price) >
                  Number(configData.selectedPackage.offer_price)
            ? Number(configData.selectedPackage.price) /
              Number(configData.selectedPackage.duration_value || 1)
            : Number(productDetails?.prices?.rental_price || 0);

        const payload = {
            id: effectiveVariantId,
            name: productDetails?.name,
            image: images?.[0]?.image,
            slug: productDetails?.slug || friendlyurl,
            friendlyurl: friendlyurl,
            type: "rent",
            offerPrice,
            sale_offer_price: productDetails?.prices?.sale_offer_price,
            sale_price: productDetails?.prices?.sale_price,
            rental_price: originalRentalPrice,
            cartItemId,
            rentalPlan: configData.plan,
            duration: configData.duration,
            selectedPackage: configData.selectedPackage,
            fromDate: configData.startDate,
            toDate: configData.endDate || null,
            rentalCharges: configData.rentalCharges || null,
        };

        dispatch(addToRentCart(payload));
        for (let i = 1; i < configData.qty; i += 1) {
            dispatch(addToRentCart(payload));
        }
    };

    // ── Handle modal submit (new config or edit) ──
    const handleConfigureSubmit = (configData) => {
        const planLabel =
            ALL_RENTAL_PLANS.find((p) => p.key === configData.plan)?.label || "Rental";
        const configEntry = {
            id:
                editingConfigId ||
                buildCartItemId(configData.plan, configData.duration, configData.startDate),
            plan: configData.plan,
            qty: configData.qty,
            duration: configData.duration,
            startDate: configData.startDate,
            endDate: configData.endDate || null,
            price: configData.price,
            originalPrice: configData.originalPrice,
            discountPercent: configData.discountPercent,
            selectedPackage: configData.selectedPackage,
            rentalCharges: configData.rentalCharges || null,
            label: `${planLabel} Rental`,
        };

        if (editingConfigId) {
            dispatch(removeFromRentCart(editingConfigId));
            addRentConfigToCart(configData, configEntry.id);
            setRentConfigurations((prev) => {
                const next = prev.map((c) =>
                    c.id === editingConfigId ? configEntry : c
                );
                saveStoredConfigs(effectiveVariantId, next);
                return next;
            });
            toast.success("Configuration updated");
        } else {
            addRentConfigToCart(configData, configEntry.id);
            setRentConfigurations((prev) => {
                const next = [...prev, configEntry];
                saveStoredConfigs(effectiveVariantId, next);
                return next;
            });
            toast.success("Configuration added");
        }

        setEditingConfigId(null);
        setShowConfigureModal(false);
    };

    const handleEditConfig = (configId) => {
        setEditingConfigId(configId);
        setShowConfigureModal(true);
    };

    const handleDeleteConfig = (configId) => {
        dispatch(removeFromRentCart(configId));
        setRentConfigurations((prev) => {
            const next = prev.filter((c) => c.id !== configId);
            saveStoredConfigs(effectiveVariantId, next);
            return next;
        });
        toast.success("Configuration removed");
    };

    const handleCloseConfigureModal = () => {
        setShowConfigureModal(false);
        setEditingConfigId(null);
    };

    function handleAddToCart(type, productData) {
        const cartItemId = generateUUID();
        if (type === "rent") {
            // Rent always opens configure modal
            setEditingConfigId(null);
            setShowConfigureModal(true);
            return;
        }
        dispatch(addToBuyCart({ ...productData, cartItemId }))
        toast.success("Product added to cart")
    }

    const descriptionHtml = product?.description || "";
    const plainDescription = descriptionHtml.replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
    const shouldShowReadMore = plainDescription.length > 320;

    const editingConfig = rentConfigurations.find((c) => c.id === editingConfigId);

    const formatMoney = (value) => {
        const number = Number(value);
        if (!Number.isFinite(number)) return "Quote on request";
        return `$${number.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        })}`;
    };

    return (
        <div className="template-temp1">
            <Header />
            <div className="product-details">
                <div className="product-left">

                    <button
                        type="button"
                        className="product-back-button"
                        onClick={() => navigate(-1)}
                    >
                        <IoArrowBack /> Back
                    </button>

                    <div className="image-slider">
                        {images.length > 0 && (
                            <>
                                <div className="main-image-wrapper">
                                    <img
                                        src={images[currentIndex].image}
                                        alt="Product" className="main-image" />
                                    <div className="zoom-container">
                                        <FaSearchPlus
                                            className="search-plus"
                                            onMouseEnter={() => setIsZoomed(true)}
                                            onMouseLeave={() => setIsZoomed(false)}
                                        />
                                        {isZoomed && (
                                            <div className="zoom-preview">
                                                <img src={images[currentIndex].image} />
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </>
                        )}
                        <button className="arrow left" onClick={handlePrev}>
                            <IoArrowBack />
                        </button>
                        <button className="arrow right" onClick={handleNext}>
                            <IoArrowForward />
                        </button>
                    </div>



                    <div className="thumbnail-section">
                        {images.map((img, index) => (
                            <img
                                key={index}
                                src={img.image}
                                alt={`Thumbnail ${index}`}
                                className={`thumbnail ${index === currentIndex ? 'active' : ''}`}
                                onClick={() => setCurrentIndex(index)}
                            />
                        ))}
                    </div>
                    <div className="product-name">{productDetails?.name}</div>
                    <div className="product-description-section">
                        <div
                            className={`product-description ${isDescriptionExpanded ? "expanded" : "collapsed"}`}
                            dangerouslySetInnerHTML={{ __html: descriptionHtml }}
                        ></div>
                        {shouldShowReadMore && (
                            <button
                                type="button"
                                className="product-description-toggle"
                                onClick={() => setIsDescriptionExpanded((prev) => !prev)}
                            >
                                {isDescriptionExpanded ? "Read less" : "Read more"}
                            </button>
                        )}
                    </div>
                </div>
                <div className="product-right-column">
                    <div className={`product-right ${selectedOption === "buy" ? "buy-bg" : "rent-bg"}`}>
                        <div className='product-right-listingtype'>
                            <div className='listing-type-text'>
                                {productDetails?.varient_listing_type}
                            </div>

                            <div className='wishlist-icon-wrapper'>
                                <Wishlist
                                    productData={productDetails}
                                    selectedOption={selectedOption}
                                    wishListed={wishListed}
                                    onLoad={fetchIsWishlist}
                                />
                            </div>
                        </div>
                        <div className='product-right-title'>{productDetails?.name}</div>

                        {productDetails?.options && productDetails.options.length > 0 && (
                            <div className="variant-options-container">
                                <div className="variant-options-grid">
                                    {productDetails.options.map((option) => (
                                        <div key={option.id} className="variant-option-item">
                                            <span className="variant-type-label">{option.variant_type}</span>
                                            <span className="variant-option-value">{option.variant_option}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        <div className="radio-group">
                            {productDetails?.varient_listing_type && (
                                <>
                                    {(() => {
                                        const currentType = selectedOption;
                                        const type = productDetails.varient_listing_type;

                                        const showBuy = type === "buy" || type === "buy/rent";
                                        const showRent = type === "rent" || type === "buy/rent";

                                        const options =
                                            currentType === "rent"
                                                ? [{ key: "rent" }, { key: "buy" }]
                                                : [{ key: "buy" }, { key: "rent" }];

                                        return (
                                            <>
                                                {options.map(({ key }) => {
                                                    if ((key === "buy" && showBuy) || (key === "rent" && showRent)) {
                                                        const rentPlanMeta = ALL_RENTAL_PLANS.find(p => p.key === selectedPlanKey) || ALL_RENTAL_PLANS[0];
                                                        const rentUnitLabel = rentPlanMeta.unit.charAt(0).toUpperCase() + rentPlanMeta.unit.slice(1);
                                                        const price =
                                                            key === "buy"
                                                                ? productDetails.prices?.sale_offer_price
                                                                : (activePackage ? activePackage.offer_price : productDetails.prices?.rental_price);
                                                        const oldPrice =
                                                            key === "buy"
                                                                ? productDetails.prices?.sale_price
                                                                : (activePackage && Number(activePackage.price) > Number(activePackage.offer_price) ? activePackage.price : null);

                                                        const isActive = currentType === key;

                                                        return (
                                                            <div key={key}>
                                                                <div
                                                                    className="d-flex justify-content-between mt-3"
                                                                    onClick={() => {
                                                                        if (currentType !== key) handleListingSwitch(key);
                                                                    }}
                                                                >
                                                                    <div className="single-option">
                                                                        <svg
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            width="14"
                                                                            height="14"
                                                                            viewBox="0 0 24 24"
                                                                            fill="none"
                                                                            stroke={isActive ? "#069baa" : "#535252ff"}
                                                                            strokeWidth="2"
                                                                            strokeLinecap="round"
                                                                            strokeLinejoin="round"
                                                                        >
                                                                            <circle cx="12" cy="12" r="10" />
                                                                            {isActive && <circle cx="12" cy="12" r="5" fill="#069baa" />}
                                                                        </svg>
                                                                        <label className="ms-1" style={{ cursor: "pointer" }}>
                                                                            {key === "buy" ? "Buy" : "Rent"}
                                                                        </label>
                                                                    </div>

                                                                    {key === "rent" && rentConfigurations.length === 0 && (
                                                                        <div className="option-price" style={{ fontWeight: 600 }}>
                                                                            {formatPrice(price)}
                                                                            <span style={{ fontSize: "14px", marginLeft: "4px" }}>/{rentUnitLabel}</span>
                                                                        </div>
                                                                    )}

                                                                    {key === "buy" && oldPrice && (
                                                                        <div className="product-details-offer-price">
                                                                            {oldPrice && price ? <span className="product-old-price-right">{formatPrice(oldPrice)}</span> : <span className='product-discount-right'>{formatPrice(oldPrice)}</span>}
                                                                            <span className="product-discount-right">
                                                                                {oldPrice && price
                                                                                    ? `${parseFloat((((oldPrice - price) / oldPrice) * 100).toFixed(2))}% OFF`
                                                                                    : ""}
                                                                            </span>
                                                                        </div>
                                                                    )}

                                                                </div>

                                                                {/* Rental Plan Pills — only shown when no configs yet */}
                                                                {key === "rent" && currentType === "rent" && rentConfigurations.length === 0 && (
                                                                    <div className="rent-date-section mt-2">
                                                                        <div className="tp-rent-section-label">Choose Rental Plan</div>
                                                                        <div className="tp-rent-plan-row">
                                                                            {ALL_RENTAL_PLANS.map((plan) => {
                                                                                const pkg = getPackageForPlan(pricePackages, plan.key);
                                                                                const isAvailable = !!pkg;
                                                                                const isPillActive = selectedPlanKey === plan.key && isAvailable;
                                                                                return (
                                                                                    <button
                                                                                        key={plan.key}
                                                                                        type="button"
                                                                                        className={`tp-rent-pill${isPillActive ? ' active' : ''}${!isAvailable ? ' tp-rent-pill-disabled' : ''}`}
                                                                                        onClick={() => isAvailable && setSelectedPlanKey(plan.key)}
                                                                                        disabled={!isAvailable}
                                                                                        title={!isAvailable ? `${plan.label} plan not available` : ''}
                                                                                    >
                                                                                        <span className="tp-pill-label">{plan.label}</span>
                                                                                       </button>
                                                                                );
                                                                            })}
                                                                        </div>

                                                                        {/* Package Price Display */}
                                                                        {activePackage && (
                                                                            <div className="tp-package-price-block">
                                                                                <div className="tp-pkg-left">
                                                                                    <div className="tp-pkg-plan-name">{activePackage.package_name} Plan</div>
                                                                                    <div className="tp-pkg-offer">
                                                                                        ₹{Number(activePackage.offer_price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                                        <span className="tp-pkg-period">/{rentUnitLabel}</span>
                                                                                    </div>
                                                                                </div>
                                                                                {Number(activePackage.price) > Number(activePackage.offer_price) && (
                                                                                    <div className="tp-pkg-right">
                                                                                        <span className="tp-pkg-discount">{Math.round(Number(activePackage.discount_percent))}% OFF</span>
                                                                                        <del className="tp-pkg-original">₹{Number(activePackage.price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</del>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                )}

                                                                {/* ── Configurations Section (when rent mode and has configs) ── */}
                                                                {key === "rent" && currentType === "rent" && rentConfigurations.length > 0 && (
                                                                    <div className="tp-config-section">
                                                                        <h3 className="tp-config-heading">Configuration</h3>
                                                                        {rentConfigurations.map((config) => (
                                                                            <div className="tp-config-card" key={config.id}>
                                                                                <div className="tp-config-accent" />
                                                                                <div className="tp-config-body">
                                                                                    <div className="tp-config-main">
                                                                                        <span className="tp-config-tag">{config.plan.toUpperCase()}</span>
                                                                                    </div>
                                                                                    <div className="tp-config-meta">
                                                                                        <div className="tp-config-meta-item">
                                                                                            <span className="tp-config-meta-label">Qty</span>
                                                                                            <span className="tp-config-meta-value">{String(config.qty).padStart(2, "0")}</span>
                                                                                        </div>
                                                                                        <div className="tp-config-meta-item">
                                                                                            <span className="tp-config-meta-label">Duration</span>
                                                                                            <span className="tp-config-meta-value">
                                                                                                {formatDurationDisplay(config.duration, config.plan)}
                                                                                            </span>
                                                                                        </div>
                                                                                        <div className="tp-config-meta-item">
                                                                                            <span className="tp-config-meta-label">Start Date</span>
                                                                                            <span className="tp-config-meta-value">{config.startDate}</span>
                                                                                        </div>
                                                                                        <div className="tp-config-price-wrapper">
                                                                                            <div className="tp-config-price">{formatMoney(config.price)}</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="tp-config-actions">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="tp-config-action-btn"
                                                                                        onClick={() => handleEditConfig(config.id)}
                                                                                        aria-label="Edit configuration"
                                                                                    >
                                                                                        <FiEdit2 />
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="tp-config-action-btn tp-config-action-btn--delete"
                                                                                        onClick={() => handleDeleteConfig(config.id)}
                                                                                        aria-label="Delete configuration"
                                                                                    >
                                                                                        <FiTrash2 />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                                        <button
                                                                            type="button"
                                                                            className="tp-config-add-btn"
                                                                            onClick={() => {
                                                                                setEditingConfigId(null);
                                                                                setShowConfigureModal(true);
                                                                            }}
                                                                        >
                                                                            + Add Another Configuration
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {isActive && (
                                                                    <div className='cart-btn-section mt-3'>
                                                                        {/* Buy mode: show qty stepper if already in cart, else show add button */}
                                                                        {key === "buy" && cartQty > 0 ? (
                                                                            <div className="detail-qty-stepper">
                                                                                <button
                                                                                    className="detail-qty-btn"
                                                                                    onClick={() => dispatch(decreaseBuyQty(productDetails?.id))}
                                                                                >
                                                                                    <FiMinus size={16} />
                                                                                </button>
                                                                                <span className="detail-qty-num">{cartQty}</span>
                                                                                <button
                                                                                    className="detail-qty-btn"
                                                                                    onClick={() =>
                                                                                        handleAddToCart(key, {
                                                                                            id: productDetails?.id,
                                                                                            name: productDetails?.name,
                                                                                            friendlyurl: friendlyurl,
                                                                                            type: key,
                                                                                            image: images?.[0]?.image,
                                                                                            oldPrice: productDetails?.prices?.sale_price,
                                                                                            offerPrice: productDetails?.prices?.sale_offer_price || productDetails?.prices?.sale_price,
                                                                                        })
                                                                                    }
                                                                                >
                                                                                    <FiPlus size={16} />
                                                                                </button>
                                                                            </div>
                                                                        ) : (
                                                                            /* Rent: only show "Add to Cart" if no configs; once there are configs, no button here */
                                                                            key === "rent" && rentConfigurations.length === 0 ? (
                                                                                <div className="cart-btn mt-3" onClick={() => handleAddToCart(key, {
                                                                                    id: productDetails?.id,
                                                                                    name: productDetails?.name,
                                                                                    friendlyurl: friendlyurl,
                                                                                    type: key,
                                                                                    image: images?.[0]?.image,
                                                                                    oldPrice: activePackage ? activePackage.price : null,
                                                                                    offerPrice: activePackage ? activePackage.offer_price : productDetails?.prices?.rental_price,
                                                                                    rentPerDay: activePackage ? activePackage.offer_price : productDetails?.prices?.rental_price,
                                                                                })}>
                                                                                    <div>
                                                                                        {formatPrice(price || oldPrice)}
                                                                                        {key === "rent" && <span style={{ fontSize: "14px", marginLeft: "4px" }}>/{rentUnitLabel}</span>}
                                                                                    </div>
                                                                                    <div>
                                                                                        ADD TO CART <IoArrowForward size={17} />
                                                                                    </div>
                                                                                </div>
                                                                            ) : key === "buy" ? (
                                                                                <div className="cart-btn mt-3" onClick={() =>
                                                                                    handleAddToCart(key, {
                                                                                        id: productDetails?.id,
                                                                                        name: productDetails?.name,
                                                                                        friendlyurl: friendlyurl,
                                                                                        type: key,
                                                                                        image: images?.[0]?.image,
                                                                                        oldPrice: productDetails?.prices?.sale_price,
                                                                                        offerPrice: productDetails?.prices?.sale_offer_price || productDetails?.prices?.sale_price,
                                                                                    })
                                                                                }>
                                                                                    <div>
                                                                                        {formatPrice(price || oldPrice)}
                                                                                    </div>
                                                                                    <div>
                                                                                        ADD TO CART <IoArrowForward size={17} />
                                                                                    </div>
                                                                                </div>
                                                                            ) : null
                                                                        )}
                                                                        {error && (
                                                                            <span className='text-danger text-sm'>{error}</span>
                                                                        )}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </>
                                        );
                                    })()}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <RelatedProducts productId={product?.id} varientId={productDetails?.id} />

            {/* Configure Rental Modal */}
            <ConfigureRentalModal
                show={showConfigureModal}
                onHide={handleCloseConfigureModal}
                product={{
                    id: effectiveVariantId,
                    variant_id: effectiveVariantId,
                    name: productDetails?.name,
                    image: images?.[0]?.image,
                    code: productDetails?.code,
                    subcategory_name: productDetails?.subcategory_name,
                    rental_price: productDetails?.prices?.rental_price,
                }}
                initialPlan={editingConfig?.plan || selectedPlanKey}
                initialQty={editingConfig?.qty || 1}
                initialDuration={editingConfig?.duration || 1}
                initialStartDate={editingConfig?.startDate || ""}
                packages={pricePackages}
                onSubmit={handleConfigureSubmit}
            />
        </div>
    );
}

export default Productdetails;
